import { render, staticRenderFns } from "./CrmDateField.vue?vue&type=template&id=06656b57"
import script from "./CrmDateField.vue?vue&type=script&lang=js"
export * from "./CrmDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports